import type { UtilityContext } from '@change-corgi/core/react/utilityContext';

import type { StarterDashboardRootPageDataQuery } from '../rootPageData.graphql';

type Petition = NonNullable<StarterDashboardRootPageDataQuery['petition']>;
type Viewer = NonNullable<StarterDashboardRootPageDataQuery['viewer']>;

export function getPetitionPromotionStats(petition: Petition, viewer: Viewer, i18n: UtilityContext['i18n']) {
	if (!petition.promotionStats) return null;

	// localize petition stats
	const viewersCurrencyCode = viewer.user?.country?.currency?.code;
	const viewersExchangeRate = viewer.user?.country?.currency?.exchangeRate;
	const usdAmount = i18n.amountFromBaseUnits(petition.promotionStats.usdAmount, 'USD');
	const contributionsFormatted =
		!viewersCurrencyCode || !viewersExchangeRate
			? i18n.localizeCurrency(Math.round(usdAmount), 'USD')
			: i18n.localizeCurrency(Math.round(usdAmount * viewersExchangeRate), viewersCurrencyCode);
	return {
		...petition.promotionStats,
		contributionsFormatted,
	};
}
